import { GoogleAnalyticsProxy } from './googleAnalyticsTools';

export const makeGoogleAnalyticsAdjustments = function () {
  const GAP = new GoogleAnalyticsProxy();

  // I don't know why, but GA doesn't automatically pick up the hostname.
  GAP.asap(ga => ga('set', 'hostname', document.location.hostname));

  // Don't send feature flag-relates CDs unless tracking an Experiment.
  GAP.on('buildHitTask', model => {
    if (model.get('eventAction') !== 'Experiment Viewed') {
      model.set('dimension17', undefined);
      model.set('dimension18', undefined);
    }
  });
};
